let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fe4be"), load("ffEVr"), load("kDqHr")]).then(() => parcelRequire('9JsQ8'));